<template>
    <div id="ContenidoMd" :key="$route.params.hash_slug">
        <section class="container pt-4 pb-4" v-if="content.title">
            <h1>{{ content.title }}</h1>
            <div class="mkdown" v-if="markedContent" v-html="markedContent"></div>
            <code class="fallback" v-else v-html="content.content"></code>
        </section>
        <section class="container pt-5 pb-5" v-else>
            <b-jumbotron class="text-center" header="Contenido no encontrado"
                lead="No se pudo encontrar el contenido solicitado.">
                <p>Por favor, verifica la URL o selecciona otro contenido.</p>
            </b-jumbotron>
        </section>
    </div>
</template>

<script>
import sanitizeHtml from 'sanitize-html';
import { marked } from 'marked'
import { mapGetters } from 'vuex';

export default {
    name: "ContenidoMd",
    props: {
        nonSanitized: {
            type: Boolean,
            default: true,
        }
    },
    computed: {
        ...mapGetters(['catalogosGetContenidos']),
        cHashSlug() {
            return this.$route.meta.hash_slug || this.$route.params.hash_slug;
        },
        content() {
            let content = {
                title: false,
                content: '',
            }
            try {
                const item = this.catalogosGetContenidos.find(
                    item => item.hash_slug === this.cHashSlug
                );
                if (item) {
                    content.title = item.title;
                    content.content = item.content_markdown;
                }
            } catch (e) {
                console.error('Error al procesar el contenido:', e);
            }
            return content
        },
        markedContent() {
            try {
                let html = (marked(this.content.content));
                return (!this.nonSanitized) ? sanitizeHtml(html) : html;
            } catch (e) {
                console.error('Error al procesar el contenido:', e);
                return '';
            }
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/utils/variables.scss';

#ContenidoMd {
    padding: 1.5rem;
    border-radius: 0.5rem;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

    font-size: 1.5rem;
    line-height: 1.5;

    margin: 0;
    padding: 1.5rem;
    color: #fff;
    background-color: transparent;
    border: 0px solid #ddd;
    border-radius: 0;
    box-shadow: 0 0px 0px rgba(0, 0, 0, 0.1);

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        // font-family: 'Arial, sans-serif';
        // color: #222;
        margin: 1.5rem 0;
        line-height: 1.2;
        color: $secondary;
    }

    h1 {
        font-size: 2.5rem;
        font-weight: bold;
    }

    h2 {
        font-size: 1.5rem;
        font-weight: bold;
    }

    h3 {
        font-size: 1.75rem;
        font-weight: bold;
    }

    h4 {
        font-size: 1.5rem;
        font-weight: bold;
    }

    h5 {
        font-size: 1.5rem;
        font-weight: bold;
    }

    h6 {
        font-size: 1.5rem;
        font-weight: bold;
    }

    // Paragraphs
    p {
        margin: 1.5rem 0;
        font-size: 1rem;
    }

    // Lists
    ul,
    ol {
        margin: 1.5rem 0;
        padding-left: 1.5rem;
        font-size: 1rem;
    }

    li {
        margin-bottom: 0.5rem;
        font-size: 1rem;
    }

    // Links
    a {
        color: $accent !important;
        text-decoration: none;
        font-size: 1rem;

        &:hover {
            text-decoration: underline;
        }
    }

    // Blockquote
    blockquote {
        margin: 1.5rem 0;
        padding: 1.5rem;
        background-color: #f9f9f9;
        border-left: 5px solid #ccc;
        font-style: italic;
    }

    // Code
    code {
        font-family: 'Courier New', monospace;
        background-color: #f4f4f4;
        padding: 0.1.5rem 0.4rem;
        border-radius: 0.25rem;
    }

    pre {
        font-family: 'Courier New', monospace;
        background-color: #f4f4f4;
        padding: 1.5rem;
        border-radius: 0.25rem;
        overflow-x: auto;
    }

    .fallback {
        padding: 1.5rem;
        background-color: #f8f9fa;
        border-radius: 0.5rem;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
}
</style>